import { intensityForLevel, type LevelIntensity } from '../generation/curve';

export type DifficultyLabel =
  | 'ふつう'
  | 'ハード'
  | 'スーパーハード';

export const difficultyLabels: Readonly<Record<LevelIntensity, DifficultyLabel>> = {
  normal: 'ふつう',
  hard: 'ハード',
  superhard: 'スーパーハード',
};

export function difficultyLabelForLevel(levelNumber: number): DifficultyLabel {
  return difficultyLabels[intensityForLevel(levelNumber)];
}
